export default {
  root: {
    width: '100%',
    height: '100%'
  }
};



// WEBPACK FOOTER //
// ./src/atoms/Svg/styles.js